<div class="option-box" *ngIf="showBillingInfo()">
  <div class="p-3 section-title mb-4 pl-4 position-relative font-medium font-size-heading theme-light" id="billingInfo">
    {{'public.checkout.billingInformation' | translate}}
  </div>

  <!-- FORM -->
  <div class="expandable-content-wrapper">
    <form class="mx-3" [formGroup]="billingInfoForm">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group mx-2">
            <app-input-text 
              class="mb-4"
              inputId="billingStreetAddress"
              maxLength="256"
              [label]="'public.checkout.billingStreetAddress' | translate"
              [required]="isRequired()"
              [control]="getControl('billingStreetAddress')"
              [isInvalid]="checkoutService.isInvalid(getControl('billingStreetAddress'))"
              [errorText]="
                getControl('billingStreetAddress')?.errors?.required ? ('public.checkout.errors.fieldRequired' | translate) : ''
              "
              (changeEvent)="addOrderMeta('billingStreetAddress', 'billingStreetAddress')"
              appPreventEnter
              />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group mx-2">
            <app-input-text 
              class="mb-4"
              inputId="billingHouseNo"
              maxLength="50"
              [label]="'public.checkout.billingHouseNo' | translate"
              [control]="getControl('billingHouseNo')"
              [isInvalid]="checkoutService.isInvalid(getControl('billingHouseNo'))"
              [errorText]="
                getControl('billingHouseNo')?.errors?.required ? ('public.checkout.errors.fieldRequired' | translate) : ''
              "
              (changeEvent)="addOrderMeta('billingHouseNo', 'billingHouseNo')"
              appPreventEnter
              />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group mx-2">
            <app-input-text 
              class="mb-4"
              inputId="billingPostCode"
              maxLength="20"
              [label]="'public.checkout.billingPostCode' | translate"
              [required]="isRequired()"
              [control]="getControl('billingPostCode')"
              [isInvalid]="checkoutService.isInvalid(getControl('billingPostCode'))"
              [errorText]="
                getControl('billingPostCode')?.errors?.required ? ('public.checkout.errors.fieldRequired' | translate) : ''
              "
              (changeEvent)="addOrderMeta('billingPostCode', 'billingPostCode')"
              appPreventEnter
              />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group mx-2">
            <app-input-text 
              class="mb-4"
              inputId="billingCity"
              maxLength="100"
              [label]="'public.checkout.billingCity' | translate"
              [required]="isRequired()"
              [control]="getControl('billingCity')"
              [isInvalid]="checkoutService.isInvalid(getControl('billingCity'))"
              [errorText]="
                getControl('billingCity')?.errors?.required ? ('public.checkout.errors.fieldRequired' | translate) : ''
              "
              (changeEvent)="addOrderMeta('billingCity', 'billingCity')"
              appPreventEnter
              />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group mx-2">
            <app-input-text 
              class="mb-4"
              inputId="billingState"
              maxLength="100"
              [label]="'public.checkout.billingState' | translate"
              [required]="isRequired()"
              [control]="getControl('billingState')"
              [isInvalid]="checkoutService.isInvalid(getControl('billingState'))"
              [errorText]="
                getControl('billingState')?.errors?.required ? ('public.checkout.errors.fieldRequired' | translate) : ''
              "
              (changeEvent)="addOrderMeta('billingState', 'billingState')"
              appPreventEnter
              />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group mx-2">
            <div class="input-group mb-4">
              <select class="form-control" 
                onchange="this.dataset.chosen = this.value"
                id="billingCountry" 
                [formControl]="getControl('billingCountryId')"
                [ngStyle]="isIOSApp ? iosSelectStyles : null"
                [ngClass]="{
                  'is-invalid': checkoutService.isInvalid(getControl('billingCountryId')),
                  'populated': getControl('billingCountryId').value
                }"
                (change)="addOrderMeta('billingCountryId', 'billingCountryId')"
                >
                <option value=""></option>
                <option *ngFor="let country of countriesList" value="{{ country.id }}">{{ country.name }}</option>
              </select>
              <label for="billingCountry" class="placeholder font-size-primary">
                {{ 'public.checkout.billingCountry' | translate }} 
                <ng-container *ngIf="isRequired()">*</ng-container>
                <ng-container *ngIf="!isRequired()">{{ 'public.global.optional' | translate }}</ng-container>
              </label>
              <div class="invalid-feedback font-size-secondary" *ngIf="checkoutService.showErrors(getControl('billingCountryId'))">
                <span *ngIf="getControl('billingCountryId').errors.required">{{ 'public.checkout.errors.fieldRequired' | translate }}.</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="form-group row ml-4" *ngIf="auth.isUserLoggedIn()">
    <div class="loading-screen d-flex justify-content-center align-items-center w-100" *ngIf=" customerDetailsChanged() && customerDetailsUpdateStatus === 'LOADING'">
      <div class="d-flex flex-column text-center">
        <div class="lds-ripple mx-auto"><div></div><div></div></div>
        <div class="loading-message">{{'public.load.loadingMessage' | translate}}</div>
      </div>
    </div>
    <div class="font-size-secondary" *ngIf=" customerDetailsChanged() && customerDetailsUpdateStatus !== 'LOADING'">
      <label class="custom-checkbox-label">
        <input class="checkbox" type="checkbox" (throttledClick)="updateCustomerDetails()" appPreventDoubleClick
        [throttleTime]="3000" />
        <span> {{'public.checkout.saveCustomerDetailsForFuture' | translate}}</span>
      </label>
    </div>
    <div class="input-group valid-feedback font-size-secondary" *ngIf="customerDetailsUpdateStatus === 'SUCCESS'">
      <span> {{'public.checkout.customerDetailsUpdateSuccess' | translate}}</span>
    </div>
    <div class="input-group invalid-feedback font-size-secondary" *ngIf="customerDetailsUpdateStatus === 'FAILED'">
      <span> {{'public.checkout.errors.customerDetailsUpdateFailed' | translate}}</span>
    </div>
  </div> 
</div>